
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaidarshancab() {



    const cardData =
    {
        keyword: 'Mumbai Darshan Cab',
        heading: 'S9 Travels: Mumbai Darshan Cab',
        headingDescription: 'S9 Travels offers an unforgettable Mumbai Darshan Cab service, providing you with a comfortable and convenient way to explore the iconic landmarks of Mumbai. Whether you are visiting the Gateway of India, Marine Drive, Siddhivinayak Temple, or any other famous site, our experienced drivers ensure that you enjoy every moment of your sightseeing tour. Our well-maintained cabs offer spacious interiors, ensuring a relaxed ride while you take in the beauty and culture of Mumbai. With flexible itineraries and professional service, S9 Travels guarantees a memorable and hassle-free Mumbai Darshan experience.',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "An iconic monument and Mumbai’s most recognized landmark, the Gateway of India was built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this grand archway is a favorite spot for tourists and photographers. From here, you can take a ferry to Elephanta Caves or enjoy a relaxing boat ride along the coastline."
    },
    {
      "title": "Marine Drive",
      "description": "Also known as the 'Queen’s Necklace,' Marine Drive is a picturesque 3.6 km-long boulevard along the Arabian Sea. Lined with Art Deco buildings, this waterfront is perfect for a leisurely stroll, especially during sunset when the entire stretch lights up beautifully. Locals and tourists gather here to enjoy the cool breeze and the sound of waves crashing against the shore."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, about 11 km from Mumbai, these UNESCO-listed rock-cut caves date back to the 5th–7th century. The caves are famous for their intricate sculptures and carvings dedicated to Lord Shiva, including the massive three-headed Shiva statue, 'Trimurti.' The ferry ride from the Gateway of India to Elephanta Island offers stunning views of Mumbai’s skyline."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
      "description": "A UNESCO World Heritage Site, CST is one of Mumbai’s most stunning architectural landmarks. Built in 1887, this railway station showcases Victorian Gothic Revival architecture with intricate stone carvings, turrets, and stained-glass windows. It is one of the busiest railway stations in India and a symbol of Mumbai’s colonial past."
    },
    {
      "title": "Colaba Causeway",
      "description": "A bustling shopping street near the Gateway of India, Colaba Causeway is a paradise for shopaholics. From trendy fashion and jewelry to antiques and handicrafts, you can find a variety of items at bargain prices. The area is also home to famous cafes and restaurants like Café Mondegar and Leopold Café, making it a great spot for both shopping and dining."
    },
    {
      "title": "Juhu Beach",
      "description": "One of Mumbai’s most popular beaches, Juhu Beach is famous for its street food stalls serving local delights like vada pav, pav bhaji, and pani puri. The beach is a favorite among joggers, tourists, and Bollywood celebrities who reside in the nearby upscale area. The evening views of the Arabian Sea here are breathtaking."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects the suburbs of Bandra with South Mumbai. Driving across the sea link offers a spectacular view of the Mumbai skyline, especially at night when the bridge is beautifully illuminated."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "Dedicated to Lord Ganesha, Siddhivinayak Temple is one of Mumbai’s most revered temples. Built in 1801, this temple attracts millions of devotees, including Bollywood celebrities and politicians. Tuesdays are considered particularly auspicious, and long queues of worshippers can be seen seeking blessings from the deity."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Located on a small islet in the Arabian Sea, Haji Ali Dargah is a revered Islamic shrine and a stunning architectural marvel. Built in memory of Saint Pir Haji Ali Shah Bukhari, this Indo-Islamic structure is accessible via a narrow causeway that gets submerged during high tide. It is a must-visit for those seeking spiritual solace and scenic beauty."
    },
    {
      "title": "Film City",
      "description": "Spread over 500 acres in Goregaon, Film City is the heart of Bollywood, where many Hindi movies and TV shows are shot. Visitors can take guided tours to witness film sets, shooting locations, and studios. If you're lucky, you might even catch a glimpse of a Bollywood star in action!"
    }
],

"services": [
  {
    "name": "Mumbai Darshan Cab Service",
    "description": "S9 Travels offers reliable Mumbai Darshan cab services, providing you with a comfortable ride to explore the key attractions of Mumbai. From historical landmarks to modern marvels, our expert chauffeurs will ensure a smooth and enjoyable journey throughout the city."
  },
  {
    "name": "Book Mumbai Darshan Taxi",
    "description": "Booking a Mumbai Darshan taxi with S9 Travels is easy and convenient. Whether you're visiting Mumbai for the first time or exploring the city's famous spots again, we offer flexible booking options for a comfortable city tour."
  },
  {
    "name": "Affordable Mumbai City Tour by Taxi",
    "description": "Explore Mumbai with an affordable city tour by taxi. S9 Travels offers budget-friendly Mumbai Darshan services, allowing you to visit top tourist spots like the Gateway of India, Marine Drive, and Chhatrapati Shivaji Maharaj Terminus without compromising comfort."
  },
  {
    "name": "Private Mumbai City Sightseeing Tour",
    "description": "Enjoy a private sightseeing tour of Mumbai with S9 Travels. Our private cabs offer you the flexibility to explore the city's attractions at your own pace. Experience the beauty and culture of Mumbai with a personal chauffeur dedicated to your comfort."
  },
  {
    "name": "Mumbai Local Sightseeing in Taxi",
    "description": "Take a taxi for a local sightseeing tour in Mumbai. S9 Travels provides dedicated local tours covering popular spots like Juhu Beach, Elephanta Caves, Haji Ali, and more, ensuring a comfortable and relaxed travel experience."
  },
  {
    "name": "Luxury Taxi for Mumbai Darshan",
    "description": "Travel in luxury with our premium taxi service for Mumbai Darshan. S9 Travels offers luxury vehicles for a stylish and comfortable sightseeing experience. Enjoy the city's beauty while relaxing in comfort, with professional chauffeurs providing personalized services."
  },
  {
    "name": "Comfortable Travel for Mumbai Tourism",
    "description": "Experience the best of Mumbai tourism with S9 Travels' comfortable travel services. Our well-maintained vehicles and experienced chauffeurs ensure you enjoy a smooth and pleasant tour of the city's iconic landmarks and hidden gems."
  },
  {
    "name": "Mumbai Historical Tour by Cab",
    "description": "Step back in time with S9 Travels' historical tour by cab. Explore Mumbai’s rich history and heritage, from the iconic Gateway of India to the historic Victoria Terminus, and discover the stories behind the city's landmarks in comfort and style."
  },
  {
    "name": "Group Travel for Mumbai Darshan",
    "description": "S9 Travels offers group travel services for Mumbai Darshan. Whether you're traveling with family, friends, or colleagues, we provide spacious and comfortable vehicles to accommodate large groups, making your sightseeing experience hassle-free and enjoyable."
  },
  {
    "name": "Mumbai Heritage Tour by Taxi",
    "description": "Explore Mumbai's heritage with a dedicated heritage tour by taxi. S9 Travels takes you to the city’s historical landmarks, such as the Elephanta Caves and the historic forts of Mumbai, with a professional driver providing insights into the city's rich cultural history."
  }
],

"tableData": [
  ["Mumbai Darshan Cab Service", "Book Mumbai Darshan Taxi"],
  ["Affordable Mumbai City Tour by Taxi", "Private Mumbai City Sightseeing Tour"],
  ["Mumbai Local Sightseeing in Taxi", "Luxury Taxi for Mumbai Darshan"],
  ["Comfortable Travel for Mumbai Tourism", "Mumbai Historical Tour by Cab"],
  ["Group Travel for Mumbai Darshan", "Mumbai Heritage Tour by Taxi"],
  ["", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Tour",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai Darshan cab service, perfect for exploring the city’s most iconic landmarks. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth and enjoyable ride with air conditioning, ample space, and plush seating, making your sightseeing experience more comfortable."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that a city tour requires punctuality. Our Mumbai Darshan cab service ensures timely pick-ups and drop-offs, so you can visit all the major attractions in Mumbai without delays. Whether you’re touring for leisure or a special occasion, we provide reliable service throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced and Knowledgeable Drivers",
    "WhyChoosedescription": "Our professional drivers are familiar with the best routes in Mumbai and have extensive knowledge of the city's history and culture. They ensure that you have a smooth and informative journey while visiting the popular landmarks, making your Mumbai Darshan tour even more enjoyable."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Mumbai Darshan cab services. We provide transparent pricing with no hidden charges. You’ll receive a clear breakdown of the cost at the time of booking, so you can plan your trip budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort During Your Tour",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as GPS tracking, airbags, and seat belts to ensure a secure and comfortable journey as you explore Mumbai’s major tourist attractions."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Mumbai Darshan trip. Whether you want to start your sightseeing early in the morning or explore the city at night, we’re available to provide reliable service at any time of the day."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Mumbai Tour",
    "WhyChoosedescription": "We understand that every traveler has unique preferences. Whether you want to visit specific landmarks or explore hidden gems of the city, we offer customizable itineraries for your Mumbai Darshan to make your experience personal and memorable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai Darshan cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or reach out to our customer service team for personalized assistance, ensuring a quick and smooth booking experience."
  }
]













    }
    const faqData = [
        [
          {
            question: 'How can I book a Mumbai Darshan cab?',
            answer: 'Booking a Mumbai Darshan cab is easy! You can book your ride through our website, mobile app, or by contacting our customer service team for personalized assistance. We’ll ensure a smooth and comfortable city tour for you.',
          },
          {
            question: 'What are the key attractions included in a Mumbai Darshan tour?',
            answer: 'A Mumbai Darshan tour typically includes major attractions like the Gateway of India, Marine Drive, Elephanta Caves, Chhatrapati Shivaji Maharaj Terminus, Siddhivinayak Temple, Haji Ali Dargah, and more. We can customize the itinerary based on your interests.',
          },
          {
            question: 'How long does a Mumbai Darshan tour take?',
            answer: 'A typical Mumbai Darshan tour lasts 6-8 hours, covering the city’s key attractions. However, the duration can be adjusted based on your preferences and the number of places you wish to visit.',
          },
          {
            question: 'Can I customize my Mumbai Darshan tour itinerary?',
            answer: 'Yes, we offer customized Mumbai Darshan tours based on your preferences. You can request specific attractions to be included or even extend the tour if you wish to explore more of the city.',
          },
          {
            question: 'Is the Mumbai Darshan cab service available for half-day and full-day tours?',
            answer: 'Yes, our Mumbai Darshan cab service is available for both half-day and full-day tours. Whether you’re looking for a short tour or a more in-depth exploration of the city, we can tailor the trip to meet your needs.',
          },
          {
            question: 'Are the drivers experienced for a Mumbai Darshan tour?',
            answer: 'Yes, all our drivers are experienced, knowledgeable about the city’s landmarks, and can guide you through the key attractions. They ensure a safe and enjoyable ride throughout your tour of Mumbai.',
          },
          {
            question: 'Do you provide pick-up and drop-off services for Mumbai Darshan tours?',
            answer: 'Yes, we provide convenient pick-up and drop-off services from any location in Mumbai, including hotels, homes, or specific landmarks, to start and end your Mumbai Darshan tour.',
          },
          {
            question: 'What types of vehicles are available for Mumbai Darshan tours?',
            answer: 'We offer a range of vehicles for Mumbai Darshan tours, including sedans, SUVs, and luxury vehicles like the Toyota Innova. Choose the vehicle that suits your group size and comfort requirements.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai Darshan tour?',
            answer: 'S9 Travels offers a reliable, comfortable, and safe Mumbai Darshan cab service. With professional drivers, well-maintained vehicles, and excellent customer service, we ensure a memorable experience as you explore the best of Mumbai.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a Mumbai Darshan cab with S9 Travels, and it was a fantastic experience. The driver was friendly and knowledgeable about the city’s history and attractions. We had a smooth and comfortable ride, and the whole tour was well-organized. Highly recommend S9 Travels for anyone looking for a city tour!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our Mumbai Darshan tour with S9 Travels was amazing. The driver was courteous and took us to all the major attractions of the city. The car was clean and well-maintained, and we felt safe and comfortable throughout the trip. It was a wonderful way to explore Mumbai in a day.”',
        },
      ];
      
      
      
      
      
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
      
      


    return (
        <div>
        

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/84.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaidarshancab;